// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-4MR8R";
var _3 = "active-BvdxW";
var _4 = "confirmed-3Bj8p";
var _5 = "header-1YGKh";
var _6 = "header_rate-uIwq4";
var _7 = "header_description-6l01g";
var _8 = "header_info-3fHN2";
var _9 = "header_price-2zqfp";
var _a = "content-3aF0z";
var _b = "button-3HmTz";
var _c = "button_reject-1crF2";
export { _1 as "__esModule", _2 as "wrapper", _3 as "active", _4 as "confirmed", _5 as "header", _6 as "header_rate", _7 as "header_description", _8 as "header_info", _9 as "header_price", _a as "content", _b as "button", _c as "button_reject" }
export default { "__esModule": _1, "wrapper": _2, "active": _3, "confirmed": _4, "header": _5, "header_rate": _6, "header_description": _7, "header_info": _8, "header_price": _9, "content": _a, "button": _b, "button_reject": _c }
